export function getSlug(name, separator, joiner) {
  return name.split(separator).join(joiner);
}
